import PropTypes from 'prop-types';
import { Image, Paragraph } from '@qga/roo-ui/components';
import { qantasQff } from '@qga/roo-ui/logos';
import { FormattedNumber } from 'components/Formatters';
import { DataContainer, H2, LogoContainer, PointsContainer } from './primitives';

const QFFPointsItem = ({ memberNumber, earnedPoints, awardedPoints }) => (
  <PointsContainer>
    <LogoContainer>
      <Image src={qantasQff} alt="Qantas Frequent Flyer Logo" />
    </LogoContainer>
    <DataContainer>
      {!!earnedPoints && (
        <H2>
          <FormattedNumber number={earnedPoints} decimalPlaces={0} /> Qantas Points earned
        </H2>
      )}
      {!!awardedPoints && (
        <H2>
          <FormattedNumber number={awardedPoints} decimalPlaces={0} /> Qantas Points awarded
        </H2>
      )}
      <Paragraph mb={0} lineHeight="20px">
        Awarded to Frequent Flyer Number {memberNumber}.
      </Paragraph>
      <Paragraph mb={0} lineHeight="20px">
        Qantas Points are awarded up to 8 weeks after check-out.
      </Paragraph>
    </DataContainer>
  </PointsContainer>
);

QFFPointsItem.propTypes = {
  memberNumber: PropTypes.string.isRequired,
  earnedPoints: PropTypes.number,
  awardedPoints: PropTypes.number,
};

export default QFFPointsItem;
